import AuthenticationService from '@/services/Authentication';
import { permissions } from '../config';

export default (to, from, next) => {
  let { name } = to;
  name = name.toUpperCase();
  const { userFeatures } = AuthenticationService;
  const { userPermissions } = AuthenticationService;
  const isHome = name === 'HOME';
  const body = document.querySelector('#app');
  body.className = name;
  if (isHome) {
    next();
    return;
  }
  
  // Check if the route has a corresponding permission entry
  const routePermission = permissions[name];
  if (!routePermission) {
    console.warn(`No permission configuration found for route: ${name}`);
    // Allow access if no permission is defined (or you can change this to deny access)
    next();
    return;
  }
  
  const hasPermission = !!userFeatures && userFeatures.indexOf(routePermission.code) !== -1;
  const hasAccess = hasPermission || userPermissions.isSysAdmin || userPermissions.isDevAdmin;
  if (hasAccess) {
    next();
    return;
  }
  const redirectRoute = {
    path: '/401',
    query: {
      redirect: to.fullPath,
    },
  };
  next(redirectRoute);
};
